var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"page_section__wrap"},[_c('div',{staticClass:"page_section overflow-hidden"},[_c('bread',{staticClass:"position-relative z-index-10",attrs:{"links":_vm.contractBread,"options":['edit', 'archive']},on:{"on-edit":_vm.onEdit,"on-archive":_vm.onArchive}}),(_vm.contract)?_c('router-view'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }